import CreatePayment from './create-payment';

window.addEventListener('load', () => {
    const isOrderPaymentsPage = !!document.querySelector('.orders-payment');

    if (!isOrderPaymentsPage) return;

    const orderIdElement = document.querySelector('.orders-payment__order-id');
    const userIdElement = document.querySelector('.orders-payment__user-id');
    const userPhoneElement = document.querySelector('.orders-payment__user-phone');
    const userEmailElement = document.querySelector('.orders-payment__user-email');
    const orderAmountElement = document.querySelector('.orders-payment__order-amount');

    const orderId = orderIdElement ? orderIdElement.dataset.id : '';
    const userId = userIdElement ? userIdElement.dataset.id : '';
    const userPhone = userPhoneElement ? userPhoneElement.dataset.phone : '';
    const userEmail = userEmailElement ? userEmailElement.dataset.email : '';
    const amount = orderAmountElement ? orderAmountElement.dataset.amount : '';

    CreatePayment({
        orderId,
        userEmail,
        userPhone,
        userId,
        amount,
        redirectUrlForSuccess: `${window.location.origin}/profile/orders/payment/success`,
        redirectUrlForFail: `${window.location.origin}/profile/orders/payment/fail`,
    });
});